export default {
  header: {
    title: "Services Cloud",
    subtitle: "Connectez vos comptes cloud pour importer et gérer vos ressources"
  },
  infoBanner: {
    title: "Connexion sécurisée",
    description: "Vos identifiants sont stockés de manière sécurisée et ne sont jamais partagés. Utilisez des credentials avec les permissions minimales nécessaires."
  },
  providers: {
    azure: "Microsoft Azure",
    aws: "Amazon Web Services",
    gcp: "Google Cloud Platform"
  },
  status: {
    connected: "Connecté",
    notConnected: "Non connecté"
  },
  details: {
    lastSync: "Dernière synchro:",
    resources: "Ressources:",
    never: "Jamais"
  },
  actions: {
    test: "Tester",
    configure: "Configurer",
    connect: "Connecter"
  },
  disconnect: {
    confirm: "Êtes-vous sûr de vouloir déconnecter ce service cloud ?"
  },
  testConnection: {
    alert: "Test de connexion {{provider}}..."
  },
  modal: {
    title: "Configurer {{provider}}",
    subtitle: "Entrez vos identifiants pour connecter votre compte cloud",
    cancel: "Annuler",
    save: "Enregistrer",
    security: {
      title: "Sécurité",
      description: "Assurez-vous d'utiliser des identifiants avec les permissions minimales nécessaires. Ne partagez jamais vos clés d'accès."
    },
    azure: {
      tenantId: "Tenant ID",
      clientId: "Client ID (Application ID)",
      clientSecret: "Client Secret",
      subscriptionId: "Subscription ID",
      tenantIdPlaceholder: "00000000-0000-0000-0000-000000000000"
    },
    aws: {
      accessKeyId: "Access Key ID",
      secretAccessKey: "Secret Access Key",
      region: "Région par défaut",
      regions: {
        usEast1: "US East (N. Virginia)",
        usWest2: "US West (Oregon)",
        euWest1: "EU (Ireland)",
        euCentral1: "EU (Frankfurt)",
        apSoutheast1: "Asia Pacific (Singapore)"
      }
    },
    gcp: {
      projectId: "Project ID",
      serviceAccountKey: "Service Account Key (JSON)",
      serviceAccountKeyPlaceholder: '{"type": "service_account", ...}'
    }
  }
};
